import React from 'react';
import { Card, Descriptions, Tag, Spin, Button, Space } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { useVoucherDetail } from '../../hooks/useVouchers';

const VoucherDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { voucher, loading } = useVoucherDetail(id || '');

  if (loading) return <Spin size="large" style={{ display: 'block', margin: '40px auto' }} />;
  if (!voucher) return <Card>Không tìm thấy voucher.</Card>;

  const formattedValue = voucher.type === 'percentage'
    ? `${voucher.value}%`
    : voucher.value.toLocaleString('vi-VN');

  return (
    <Space direction="vertical" size={16} style={{ width: '100%' }}>
      <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/vouchers')}>Quay lại</Button>
      <Card title={`Voucher · ${voucher.code}`}>
        <Descriptions column={2} bordered size="small">
          <Descriptions.Item label="Mã"><code>{voucher.code}</code></Descriptions.Item>
          <Descriptions.Item label="Nguồn">{voucher.source || '—'}</Descriptions.Item>
          <Descriptions.Item label="Loại"><Tag>{voucher.type}</Tag></Descriptions.Item>
          <Descriptions.Item label="Giá trị">{formattedValue}</Descriptions.Item>
          <Descriptions.Item label="Giảm tối đa">
            {voucher.max_discount ? voucher.max_discount.toLocaleString('vi-VN') : '—'}
          </Descriptions.Item>
          <Descriptions.Item label="Trạng thái">
            <Tag color={voucher.status === 'active' ? 'success' : voucher.status === 'expired' ? 'error' : 'default'}>
              {voucher.status}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Đã dùng">{voucher.usage_count ?? 0}</Descriptions.Item>
          <Descriptions.Item label="Giới hạn tổng">{voucher.usage_limit_total ?? '—'}</Descriptions.Item>
          <Descriptions.Item label="Bắt đầu">
            {voucher.start_date ? dayjs(voucher.start_date).format('DD/MM/YYYY HH:mm') : '—'}
          </Descriptions.Item>
          <Descriptions.Item label="Kết thúc">
            {voucher.end_date ? dayjs(voucher.end_date).format('DD/MM/YYYY HH:mm') : '—'}
          </Descriptions.Item>
          <Descriptions.Item label="Mô tả" span={2}>{voucher.description || '—'}</Descriptions.Item>
          <Descriptions.Item label="Tenant ID" span={2}><code>{voucher.tenant_id || '—'}</code></Descriptions.Item>
          <Descriptions.Item label="Ngày tạo">
            {voucher.created_at ? dayjs(voucher.created_at).format('DD/MM/YYYY HH:mm') : '—'}
          </Descriptions.Item>
          <Descriptions.Item label="Cập nhật">
            {voucher.updated_at ? dayjs(voucher.updated_at).format('DD/MM/YYYY HH:mm') : '—'}
          </Descriptions.Item>
        </Descriptions>
      </Card>
    </Space>
  );
};

export default VoucherDetail;
export { VoucherDetail };
